import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch } from "react-router-dom";

// Pages
import Home from "./pages/Home.jsx";
import About from "./pages/About.jsx";
import Contact from "./pages/Contact.jsx";
import Playground from "./pages/Playground.jsx";

import BlogPost from './components/BlogPost/BlogPost';
import NewsletterProvider from './components/Newsletter/NewsletterProvider';
import useLenis from './hooks/useLenis';

import * as serviceWorker from "./serviceWorker";
import { AnimatePresence } from "framer-motion";
import { GlobalStyle } from "./components/StyledComponents/StyledComponents.jsx";
import { ThemeProvider } from "styled-components";
import theme from "./components/StyledComponents/Theme";

import Posts from '../src/posts/Posts';

// Google Analytics
import ReactGA from "react-ga";

function App() {
    // Inicializar Lenis smooth scroll con configuración optimizada
    useLenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // easeOutExpo suave
        smooth: true,
        mouseMultiplier: 1,
        smoothTouch: false, // Mejor UX en móviles con scroll nativo
        touchMultiplier: 2,
        normalizeWheel: true,
    });

    useEffect(() => {
        if(window.location.hostname !== "localhost") {
            // Google Analytics ID goes here.
            let trackingId = "123";

            ReactGA.initialize(trackingId);
            ReactGA.pageview('/');
        }
    }, []);

    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle />
            <NewsletterProvider>
                <BrowserRouter>
                    <AnimatePresence>
                        <Switch>
                            <Route exact path="/">
                                <Home />
                            </Route>

                            <Route path="/home">
                                <Home />
                            </Route>

                            <Route path="/about">
                                <About />
                            </Route>

                            <Route path="/contact">
                                <Contact />
                            </Route>

                            <Route path="/playground">
                                <Playground />
                            </Route>

                            {Posts.map((post) => {
                                return(
                                    <Route path={`/${post.route}`}>
                                        <BlogPost
                                            title={post.title}
                                            date={post.date}
                                            image={post.image}
                                            content={post.content}
                                            category={post.category}
                                            tags={post.tags}
                                            route={post.route}
                                        />
                                    </Route>
                                )
                            })}
                        </Switch>
                    </AnimatePresence>
                </BrowserRouter>
            </NewsletterProvider>
        </ThemeProvider>
    )
}

serviceWorker.unregister();
ReactDOM.render(<App />, document.getElementById('root'))
